import { jsx as _jsx } from "react/jsx-runtime";
import { ClientReferralsProgramView } from './client-referrals-program';
import { useLaunchProgramForm } from './use-launch-program-form';
import { useApiQuery } from '../../../infra/api';
import { endpoints } from '../network';
import { getSessionShop, useSession } from '../../../infra/session';
import { getSymbolForCurrency } from '../../../../app/common/money';
import { SHOP_CURRENCY } from '../../../../app/main/shops/constants';
import { useDiscountHandlers } from './use-discount-handlers';
import { useActiveProgramHandlers } from './use-active-program-handlers';
export var ClientReferralsProgramContainer = function () {
    var session = useSession().data;
    var shop = getSessionShop(session);
    var _a = useApiQuery({
        endpoint: endpoints.clientReferralProgramQuery,
        payload: {
            shopId: shop === null || shop === void 0 ? void 0 : shop.id,
        },
        options: {
            enabled: !!shop,
        },
    }), referralProgram = _a.data, isReferralProgramLoading = _a.isLoading;
    var formHandlers = useLaunchProgramForm(referralProgram, isReferralProgramLoading);
    var isReferralProgramActive = !!referralProgram;
    var isReadOnly = isReferralProgramActive || isReferralProgramLoading || formHandlers.form.formState.isSubmitting;
    var discountHandlers = useDiscountHandlers(formHandlers.form);
    var activeProgramHandlers = useActiveProgramHandlers({ referralProgram: referralProgram, form: formHandlers.form });
    return (_jsx(ClientReferralsProgramView, { form: formHandlers.form, isReadOnly: isReadOnly, isActive: isReferralProgramActive, shopCurrencySymbol: getSymbolForCurrency((shop === null || shop === void 0 ? void 0 : shop.currency) || SHOP_CURRENCY.usd), onSubmit: formHandlers.form.handleSubmit(formHandlers.onSubmitForm), discountHandlers: discountHandlers, onDeactivate: activeProgramHandlers.onDeactivate, onNotifyClients: activeProgramHandlers.onNotifyClients, canNotifyClients: activeProgramHandlers.canNotifyClients }));
};
